// extracted by mini-css-extract-plugin
export default {"trafficLightCell":"eX_eY","trafficLightCell_collapsed":"eX_eZ","trafficLightCell_hidden":"eX_e0","trafficLightCell_planted":"eX_e1"};